import React from 'react';
import './StatusSelector.css';

const statusOptions = [
  { value: 'Activo', label: 'Activo', color: '#d4edda' },
  { value: 'Inactivo', label: 'Inactivo', color: '#f8d7da' },
  { value: 'Pendiente', label: 'Pendiente', color: '#fff3cd' },
  { value: 'Baja', label: 'Baja', color: '#d6d8db' },
  { value: 'En Revisión', label: 'En Revisión', color: '#cce5ff' },
];

const StatusSelector = ({ currentStatus, onSelect, onClose }) => {
  const handleStatusClick = (status) => {
    onSelect(status);
    onClose();
  };

  return (
    <div className="status-selector">
      <h3>Cambiar estado</h3>
      <div className="status-options">
        {statusOptions.map((status) => (
          <div 
            key={status.value}
            className={`status-option ${currentStatus === status.value ? 'selected' : ''}`}
            style={{ '--status-color': status.color }}
            onClick={() => handleStatusClick(status.value)}
          >
            {status.label}
          </div>
        ))}
      </div>
      <button className="cancel-button" onClick={onClose}>
        Cancelar
      </button>
    </div>
  );
};

export default StatusSelector;
